export default __webpack_public_path__ + "static/media/bateria5.57220f2d.png";